import { domainCountry } from "@/src/constants/domain"

export const partnerIdConfigCT : Record<string, string> = {
    'AE' : '10000001',
    'SA' : '10000002',
    'BH' : '10000003',
    'QA' : '10000004',
    'KW' : '10000005',
    'OM' : '10000006',
}

export const fetchCTPartnerId = () : string => {
    return partnerIdConfigCT[domainCountry] || partnerIdConfigCT['AE']
}